var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search-contain" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入名称", clearable: "" },
                    model: {
                      value: _vm.query.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "name", $$v)
                      },
                      expression: "query.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间", prop: "daterange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.daterange,
                      callback: function ($$v) {
                        _vm.daterange = $$v
                      },
                      expression: "daterange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建人" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.query.createUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "createUser", $$v)
                      },
                      expression: "query.createUser",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "隶属公司", prop: "merchantId" } },
                [
                  _c("YdMerchantSelector", {
                    attrs: { placeholder: "请选择隶属公司" },
                    model: {
                      value: _vm.query.merchantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "merchantId", $$v)
                      },
                      expression: "query.merchantId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchChange },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchReset },
                    },
                    [_vm._v("清空")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["limit_coupon"],
                          expression: "['limit_coupon']",
                        },
                      ],
                      staticClass: "add",
                      staticStyle: { "margin-right": "40px" },
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.addClick },
                    },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yd-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.records,
            border: "",
            size: "mini",
            pagination: _vm.pagination,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: { label: "活动名称", prop: "name", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "优惠金额",
              prop: "discountsMoney",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "隶属公司", prop: "merchantName", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "startTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "endTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建人",
              prop: "createUserName",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "createTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              prop: "statusStr",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "PV", prop: "pv", align: "center", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { label: "UV", prop: "uv", align: "center", width: "80" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              prop: "operate",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status !== 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["limit_coupon"],
                                expression: "['limit_coupon']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.getAdvertisingInfo(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    scope.row.status == 5
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["limit_coupon"],
                                expression: "['limit_coupon']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleStart(scope.row)
                              },
                            },
                          },
                          [_vm._v("上架")]
                        )
                      : _vm._e(),
                    scope.row.status == 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["limit_coupon"],
                                expression: "['limit_coupon']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleApprove(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("通过")]
                        )
                      : _vm._e(),
                    scope.row.status == 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["limit_coupon"],
                                expression: "['limit_coupon']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleFailed(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("不通过")]
                        )
                      : _vm._e(),
                    scope.row.status == 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["limit_coupon"],
                                expression: "['limit_coupon']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleFinish(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("下架")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editVisible
        ? _c("limit-coupon-edit", {
            attrs: {
              visible: _vm.editVisible,
              advertisingInfo: _vm.advertisingInfo,
            },
            on: { saveEdit: _vm.saveEdit, closeEdit: _vm.closeEdit },
          })
        : _vm._e(),
      _c("limit-coupon-detail", {
        ref: "activityDetail",
        on: { lookActive: _vm.lookActive },
      }),
      _c("limit-coupon-look", {
        ref: "limitLook",
        attrs: { visibleLook: _vm.visibleLook },
        on: { closeLook: _vm.closeLook },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }